export class MetricsContextModel {
  browser: string;
  browserVersion: string;
  device: string;
  ip: string;
  source: string;
  partner: string;

  constructor() {
  }
}
